"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.slackEventDtoSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const additionalDataSchema = zod_1.default.record(zod_1.default.string(), zod_1.default.string());
const slackEventBaseSchema = zod_1.default.object({
    eventName: zod_1.default.string(),
    additionalData: additionalDataSchema.optional(),
});
const companyInfoSchema = zod_1.default.object({
    userEmail: zod_1.default.string().optional(),
    companyId: zod_1.default.string(),
    companyName: zod_1.default.string(),
});
const userInfoSchema = zod_1.default.object({
    userEmail: zod_1.default.string(),
    companyId: zod_1.default.string().optional(),
    companyName: zod_1.default.string().optional(),
});
exports.slackEventDtoSchema = slackEventBaseSchema.and(companyInfoSchema.or(userInfoSchema));
